var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"piebox"},[_c('elevators-status-chart',{attrs:{"pie":true,"groupId":_vm.groupId,"elevators":_vm.elevators}}),_vm._v(" "),(_vm.name)?_c('h4',{attrs:{"align":"center"}},[(_vm.groupId)?_c('b-link',{attrs:{"to":{ name: 'group', params: { id: _vm.groupId } }}},[_vm._v(_vm._s(_vm.name))]):_c('span',[_vm._v(_vm._s(_vm.name))])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1304a2b0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/ElevatorsStatusSmall.vue
// module id = 767
// module chunks = 0